import { render } from "./NewsEntry.vue?vue&type=template&id=111b5675&lang=pug"
import script from "./NewsEntry.vue?vue&type=script&lang=js"
export * from "./NewsEntry.vue?vue&type=script&lang=js"

import "./NewsEntry.vue?vue&type=style&index=0&id=111b5675&lang=scss"

import exportComponent from "/schmetterlinge/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__